"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeTeamsLoadingError = removeTeamsLoadingError;
exports.fetchTeams = fetchTeams;
exports.fetchTeamsIfNeeded = fetchTeamsIfNeeded;

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var _TeamsApiClient = _interopRequireDefault(require("lead-flows-ui/api/TeamsApiClient"));

var _Teams = require("lead-flows-ui/selectors/Teams");

function requestTeams() {
  return {
    type: _ActionTypes.REQUEST_TEAMS
  };
}

function recieveTeams(teams) {
  return {
    type: _ActionTypes.RECEIVE_TEAMS,
    payload: teams
  };
}

function errorRetrievingTeams(error) {
  return {
    type: _ActionTypes.ERROR_RETRIEVING_TEAMS,
    payload: error,
    error: true
  };
}

function removeTeamsLoadingError() {
  return {
    type: _ActionTypes.REMOVE_TEAMS_LOADING_ERROR
  };
}

function fetchTeams() {
  return function (dispatch) {
    dispatch(requestTeams());
    return _TeamsApiClient.default.fetchTeams().then(function (response) {
      dispatch(recieveTeams(response));
    }, function (error) {
      dispatch(errorRetrievingTeams(error));
    }).done();
  };
}

function fetchTeamsIfNeeded() {
  return function (dispatch, getState) {
    var requestState = (0, _Teams.getTeamsRequestState)(getState());

    if (!requestState.shouldBeRequested()) {
      return;
    }

    dispatch(fetchTeams());
  };
}